import * as React from 'react';
import { Link, Redirect } from 'react-router-dom';
import * as moment from 'moment';
import colors from '../shared/colors';
import * as classNames from 'classnames';
import formatCurrency from '../services/format.currency';
import { getMonth, aggregate } from '../services/expenses.service';

export class Accounts extends React.Component<
  { accounts; expenses; showDiff; user; fetchAccounts; deleteAccount; updateAccount; history },
  { month; edit: boolean; element }
> {
  private date: Date;
  constructor(props) {
    super(props);
    this.moveUp = this.moveUp.bind(this);
    this.state = { month: 0, edit: false } as any;
    const { search } = props.location;
    if (search) {
      this.state = { ...this.state, month: parseInt(new URLSearchParams(search).get('month')) || this.state.month };
    }
  }

  moveUp(account) {
    const { accounts, updateAccount } = this.props;
    return e => {
      e.preventDefault();
      const a = { ...account };
      a.preference = (Math.max(...Object.keys(accounts).map(e => accounts[e].preference)) || 0) + 1;
      updateAccount(a);
    };
  }

  printValue(value) {
    const user = this.props.user;
    return formatCurrency(value, user);
  }

  render() {
    const { accounts, deleteAccount, expenses, showDiff, user } = this.props;
    let year = Math.floor(this.state.month / 12);
    let month = this.state.month % 12;
    if (month < 0) {
      month += 12;
    }
    if (new Date().getMonth() + month > 11) {
      month -= 12;
      year += 1;
    }
    const report = aggregate(getMonth(expenses, new Date().getMonth() + month, new Date().getFullYear() + year));
    if (this.state.edit) {
      this.props.history.push('/update-account' + `?_id=${accounts[this.state.element]._id}`);
    }

    const colorClass = account => classNames('chip center-align', account.color, colors[account.color]);
    return (
      <div>
        <div>
          <div className="center-align">
            <h5>Accounts</h5>
          </div>
        </div>
        <div className="row">
          <div className="col s12">
            <table className="highlight accounts">
              <thead>
                <tr>
                  <th>Name</th>
                  {/*<th>Color</th>*/}
                  <th>Current Balance</th>
                  {showDiff && <th>Change</th>}
                  <th />
                  <th />
                </tr>
              </thead>

              <tbody>
                {Object.keys(accounts)
                  .sort((a, b) => accounts[b].preference - accounts[a].preference)
                  .map((e, i) => (
                    <tr key={e}>
                      <td onClick={() => this.setState({ edit: true, element: e })}>
                        <div className={colorClass(accounts[e])}>{accounts[e].name}</div>
                      </td>
                      {/*<td> {accounts[e].color}</td>*/}
                      <td onClick={() => this.setState({ edit: true, element: e })}>
                        {formatCurrency(accounts[e].balance, user)}
                      </td>
                      {showDiff && (
                        <td onClick={() => this.setState({ edit: true, element: e })}>
                          {this.printValue(report.accounts[accounts[e]._id])}
                        </td>
                      )}
                      <td style={{ padding: 0 }}>
                        {!accounts[e].isCash && (
                          <Link
                            to={{
                              pathname: '/add-expense',
                              state: {
                                account: accounts[e]._id,
                                type: 'TRANSFER',
                                category: 'withdrawal'
                              }
                            }}
                          >
                            <i className="material-icons small grey-text">file_download</i>&nbsp;
                          </Link>
                        )}
                      </td>
                      <td style={{ padding: 0 }}>
                        {i !== 0 && (
                          <a href="#" onClick={this.moveUp(accounts[e])}>
                            <i className="material-icons small grey-text">arrow_upward</i>
                          </a>
                        )}
                      </td>

                      <td style={{ padding: 0 }}>
                        {!accounts[e].isCash && (
                          <a
                            className="waves-effect waves-light"
                            onClick={() => {
                              var result = confirm('Are you sure you want to delete the account?');
                              if (result) deleteAccount(accounts[e]._id);
                            }}
                          >
                            <i className="material-icons small red-text">delete</i>&nbsp;
                          </a>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/accounts/component.tsx